// Chrome/Safari fire a benign "ResizeObserver loop completed with undelivered
// notifications" error whenever an observed element resizes multiple times
// within a single frame (e.g. dragging the workflow inspector's resize
// handle, which resizes the React Flow canvas on every pointermove). It is
// not an app error, but CRA's dev overlay traps it as an uncaught exception.
// Deferring observer callbacks to the next animation frame keeps notifications
// from queuing up within one frame, which prevents the browser from ever
// hitting the loop limit.
const NativeResizeObserver = window.ResizeObserver;

if (NativeResizeObserver && !NativeResizeObserver.__patchedForLoopLimit) {
  class GuardedResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  }
  GuardedResizeObserver.__patchedForLoopLimit = true;
  window.ResizeObserver = GuardedResizeObserver;
}
